/**
 * Копирование в буфер (03.10, кадры: ссылка-приглашение и свой Telegram ID на экране
 * «Нет доступа»). Clipboard API в защищённом контексте, иначе фолбэк через readonly
 * textarea — readonly, чтобы в мини-аппе не поднималась системная клавиатура.
 * Образец — DcClientsSection.copyText.
 */
export async function copyText(text: string): Promise<boolean> {
  if (!text) return false;
  try {
    if (navigator.clipboard && window.isSecureContext) { await navigator.clipboard.writeText(text); return true; }
  } catch { /* фолбэк ниже */ }
  try {
    const ta = document.createElement("textarea");
    ta.value = text;
    ta.readOnly = true;
    ta.style.position = "fixed"; ta.style.opacity = "0"; ta.style.pointerEvents = "none";
    document.body.appendChild(ta); ta.select();
    const ok = document.execCommand("copy");
    document.body.removeChild(ta);
    return ok;
  } catch { return false; }
}
